const requireContext = require.context(".", true, /\.js$/);

export default requireContext.keys()
    .map((file) => requireContext(file));
